module.exports = __webpack_public_path__ + "static/media/comment.4d11b280.svg";